export class UsernameIsInvalidError extends Error {}

export class PasswordIsInvalidError extends Error {}

export enum UNAUTHORIZED_ERROR_TYPE {
  MISSING_CREDENTIALS = 'MISSING_CREDENTIALS',
  INCORRECT_CREDENTIALS = 'INCORRECT_CREDENTIALS',
  CONFIRMATION_CODE_REQUIRED = 'CONFIRMATION_CODE_REQUIRED',
  CONTRACT_NOT_STARTED = 'CONTRACT_NOT_STARTED',
  CONTRACT_EXPIRED = 'CONTRACT_EXPIRED',
  CONTRACT_NOT_FOUND = 'CONTRACT_NOT_FOUND',
}

/**
 * Type used when transferring information using react-router's `history.push` and `location.state` functionality.
 */
export type SignInPageLocationState = {
  loginError?: { statusCode?: number; errorType?: UNAUTHORIZED_ERROR_TYPE; data?: any };
};
